import { Formik } from 'formik'

import { ModalWrapper } from 'src/components/modal-wrapper'

import { IChallengesForm } from 'src/types'

import { useStyles } from '../../styles'

import { useItemsRemoveConfirm, useUpdateChallenge } from 'src/hooks'
import { EConfirmModalTitles } from 'src/constants'
import { ChallengeForm } from '../form.component'
import { challengeSchema } from 'src/common/validations/challenges-schema.validation'
import { useGetChallangeInfo } from 'src/hooks/challenges/use-get-challange-info.hook'

interface IProps {
  open: boolean
  handleClose: () => void
  id: string
  initial: IChallengesForm
}

export const UpdateChallengeForm = ({ open, handleClose, id, initial }: IProps) => {
  const classes = useStyles()
  const { mutateAsync } = useUpdateChallenge()
  const { data, isLoading } = useGetChallangeInfo(id, open)

  const { setRemoveConfirm, setIsLoadingModal } = useItemsRemoveConfirm()

  const handleUpdateItem = async (values: IChallengesForm) => {
    if (!values) return

    setRemoveConfirm({
      handleConfirm: async () => {
        setIsLoadingModal(true)

        await mutateAsync({
          ...values,
          id,
          end_date: values.end_date.toDate(),
          start_date: values.start_date.toDate(),
        }).finally(() => {
          handleClose()
          setIsLoadingModal(false)
        })
      },
      customModal: {
        title: EConfirmModalTitles.UPDATE,
        secondaryText: values.paid
          ? 'Paid flag is set to true. On confirmation, all users from CSV will receive payment emails and a new Reward Activity record for each such user will be created.'
          : undefined,
      },
      itemsTitles: [],
      itemsDetails: [{ text: values.name, title: 'Name' }],
      itemsRelations: [],
      itemsType: '',
    })
  }

  const isPaidDisabled = initial.paid || isLoading || (data?.pending_scans_to_approve ?? 0) > 0

  return (
    <ModalWrapper className={classes.modalWrapper} open={open} onClose={handleClose}>
      <Formik
        initialValues={initial}
        validationSchema={challengeSchema}
        onSubmit={handleUpdateItem}
      >
        <ChallengeForm
          isUpdate
          isPaidSwitchDisabled={isPaidDisabled}
          isChallangeInfoLoading={isLoading}
          itemsToApprove={data?.pending_scans_to_approve}
        />
      </Formik>
    </ModalWrapper>
  )
}
